import { querySelectedTableDOMElement } from '../../../bridge/utils/domUtils/tableSelectionDomUtils';

/**
 * Returns the active manual-column-move backlight element.
 */
export const getColumnBacklightElement = (): HTMLDivElement | null =>
    querySelectedTableDOMElement('.selected-single .ht__manualColumnMove--backlight');

/**
 * Returns the active manual-row-move backlight element.
 */
export const getRowBacklightElement = (): HTMLDivElement | null =>
    querySelectedTableDOMElement('.selected-single .ht__manualRowMove--backlight');

/**
 * Returns the active manual-column-move guideline element.
 */
export const getColumnGuidelineElement = (): HTMLDivElement | null =>
    querySelectedTableDOMElement('.selected-single .ht__manualColumnMove--guideline');

/**
 * Returns the active manual-row-move guideline element.
 */
export const getRowGuidelineElement = (): HTMLDivElement | null =>
    querySelectedTableDOMElement('.selected-single .ht__manualRowMove--guideline');
